import { FC } from 'react';
import classNames from 'classnames';
import { CardLocation } from '#home/components/card-location';
import { SeoText } from '#home/components/SeoText';
import { SeoTextLong } from '#home/components/SeoTextLong';
import homeCss from '#srcCssModules/home/home.module.scss';
import homeContentCss from '#srcCssModules/home/home-content.module.scss';
import { CardPopularCityList } from '#home/components/card-popular-city-list';
import { useHomeContext } from '#home/hooks';
import { AdvertList } from '#home/components/advert-list';
import { HomeTitle } from '#home/components';

const Content: FC = () => {
  const { advertList } = useHomeContext();

  return (
    <div className={homeCss.home__content}>
      <div
        className={classNames(
          homeContentCss.homeContent__top,
          { [homeContentCss.homeContent__top_withFullHeight]: !advertList || advertList.length === 0 },
          { [homeContentCss.homeContent__top_withoutFullHeight]: advertList && advertList.length > 0 },
        )}
      >
        <HomeTitle />
        <SeoText />
        <CardLocation />
      </div>
      <div
        className={classNames(
          homeContentCss.homeContent__bottom,
          { [homeContentCss.homeContent__bottom_withGap5]: !advertList || advertList.length === 0 },
          { [homeContentCss.homeContent__bottom_withGap4]: advertList && advertList.length > 0 },
        )}
      >
        <AdvertList />
        <CardPopularCityList />
        <SeoTextLong />
      </div>
    </div>
  );
};

export { Content };
